import { ApiHosts, handleResponseOld, makePost } from '@/redux/api/helpers';
import { PostTrackEventParams } from './analytics.types';

export const postTrackPageView = ({
    authToken,
    bidderId,
    catalogId,
    deployment,
    itemId,
    path,
    referrer,
}: PostTrackEventParams) =>
    new Promise((resolve, reject) => {
        const request = makePost({ apiPath: 'stats/page-stats', authToken, deployment, path: ApiHosts.Analytics });
        request.send({
            bidder_id: bidderId,
            catalog_id: catalogId,
            item_id: itemId,
            path,
            referrer,
            url: 'www.liveauctioneers.com',
        });

        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
